import { Box, CardMedia, Link, Typography } from "@material-ui/core";
import Circle from "../Circle/Circle.jsx";
import useStyles from "./style.js";
import PhoneIcon from "@material-ui/icons/Phone";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import MainBtn from "../MainBtn/MainBtn.jsx";
import { useMediaQuery } from "@material-ui/core";

const Banner = (props) => {
  const mobile = useMediaQuery("(max-width:768px)");

  const classes = useStyles();

  return (
    <Box
      component="div"
      className={!mobile ? classes.background : classes.backgroundMob}
    >
      <Circle circleClass={props.bannerSettings.circleClassName} />
      <Box className={!mobile ? classes.container : classes.containerMob}>
        <Box component="div" className={classes.image}>
          <CardMedia
            component="img"
            image={
              props.bannerSettings.photo ? props.bannerSettings.photo : null
            }
            className={classes.img}
          />
          <Box
            component="div"
            className={
              props.bannerSettings.smallCircle === "empty"
                ? classes.empty
                : classes.full
            }
          >
            {props.bannerSettings.smallCircle === "full" ? (
              <Typography variant="body1" className={classes.circleText}>
                {props.bannerSettings.smallCircleTitle
                  ? props.bannerSettings.smallCircleTitle
                  : null}
              </Typography>
            ) : null}
          </Box>
        </Box>
        <Box
          component="div"
          className={!mobile ? classes.text : classes.textMob}
        >
          <Typography variant="h2" className={classes.title}>
            {props.bannerSettings.title}
          </Typography>
          <Typography p="true" className={classes.paragraph}>
            {props.bannerSettings.paragraph}
          </Typography>
          {props.bannerSettings.wp && props.bannerSettings.mail ? (
            <>
              <Link
                href="https://wa.me/+50242890334"
                underline="hover"
                target="_blank"
                rel="noopener"
                className={classes.paragraph}
              >
                <PhoneIcon className={classes.icon} />
                {props.bannerSettings.wp}
              </Link>
              <Link
                href="mailto:blancoseguroapp@gmail.com"
                underline="hover"
                target="_blank"
                rel="noopener"
                className={classes.paragraph}
              >
                <MailOutlineIcon className={classes.icon} />
                {props.bannerSettings.mail}
              </Link>
            </>
          ) : null}
          <MainBtn btn={props.bannerSettings.btnSettings} />
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;
